<script lang="ts">
  import type { MoneyV2, ProductPriceRange } from "$lib/gql/gen/codegen";
  import type { PriceRange } from "$lib/gql/genCms/codegen";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import { _ } from "svelte-i18n";

  export let component = "span";
  export let variant = "body2";

  export let priceRange: PriceRange | ProductPriceRange = undefined;
  export let comparePriceRange: PriceRange | ProductPriceRange = undefined;
  export let variantPrice: MoneyV2 = undefined;
  export let variantComparePrice: MoneyV2 = undefined;
  export let locale: string = undefined;

  const findPercent = (price: string, comparePrice: string) => {
    const p = parseFloat(price);
    const cp = parseFloat(comparePrice);
    const per = Math.round((p / cp - 1) * 100);
    return per.toString() + "%";
  };

  const formatPrice = (price: number, currencyCode: string): string => {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
    }).format(price);
  };

  let price: string = "";
  $: if (variantPrice) {
    price = formatPrice(variantPrice.amount, variantPrice.currencyCode);
  } else if (
    priceRange &&
    priceRange.maxVariantPrice.amount === priceRange.minVariantPrice.amount
  ) {
    price = formatPrice(
      priceRange.maxVariantPrice.amount,
      priceRange.maxVariantPrice.currencyCode,
    );
  } else if (priceRange) {
    price =
      formatPrice(
        priceRange.minVariantPrice.amount,
        priceRange.minVariantPrice.currencyCode,
      ) +
      " - " +
      formatPrice(
        priceRange.maxVariantPrice.amount,
        priceRange.maxVariantPrice.currencyCode,
      );
  }

  let comparePrice: string = "";
  let percentage: string;
  $: if (
    variantComparePrice === null ||
    (variantComparePrice && variantComparePrice.amount === variantPrice.amount)
  ) {
    comparePrice = "";
    percentage = "";
  } else if (variantComparePrice) {
    comparePrice = formatPrice(
      variantComparePrice.amount,
      variantComparePrice.currencyCode,
    );
    percentage = findPercent(variantPrice.amount, variantComparePrice.amount);
  } else if (
    comparePriceRange &&
    comparePriceRange.maxVariantPrice.amount ===
      comparePriceRange.minVariantPrice.amount
  ) {
    comparePrice = formatPrice(
      comparePriceRange.maxVariantPrice.amount,
      comparePriceRange.maxVariantPrice.currencyCode,
    );
    percentage = findPercent(
      priceRange.minVariantPrice.amount,
      comparePriceRange.minVariantPrice.amount,
    );
  } else if (comparePriceRange) {
    comparePrice =
      formatPrice(
        comparePriceRange.minVariantPrice.amount,
        comparePriceRange.minVariantPrice.currencyCode,
      ) +
      " - " +
      formatPrice(
        comparePriceRange.maxVariantPrice.amount,
        comparePriceRange.maxVariantPrice.currencyCode,
      );
    percentage = findPercent(
      priceRange.minVariantPrice.amount,
      comparePriceRange.minVariantPrice.amount,
    );
  }
</script>

<style lang="scss">
</style>

<span class="price">
  {#if comparePrice && !(comparePriceRange && comparePriceRange.maxVariantPrice && comparePriceRange.maxVariantPrice.amount == 0)}
    <Typography {component} {variant} theme="on-surface"
      >{price}&nbsp;&nbsp;</Typography
    >
    <Typography
      {component}
      {variant}
      strikeThrough
      theme="on-surface"
      aria-label={$_("Previous price")}>{comparePrice}</Typography
    >
    {#if percentage}
      <Typography {component} {variant} theme="feedback1"
        >&nbsp;&nbsp;{percentage}</Typography
      >
    {/if}
  {:else}
    <Typography {component} {variant} theme="on-surface">{price}</Typography>
  {/if}
</span>
